<template>
  <v-layout
    :title="$t('account.title')"
    :subtitle="$t('account.subtitle')"
  >
    <HelpPage :topics="topics" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import HelpPage from "@/components/HelpPage";

export default {
  components: {
    VLayout,
    HelpPage,
  },
  computed: {
    topics() {
      return [
        {
          title: this.$t("account.account.title"),
          text: this.$t("account.account.content"),
        },
        {
          title: this.$t("account.password.title"),
          text: this.$t("account.password.content"),
        },
        {
          title: this.$t("account.personal.title"),
          text: this.$t("account.personal.content"),
        },
        {
          title: this.$t("account.newsletter.title"),
          text: this.$t("account.newsletter.content"),
        },
        {
          title: this.$t("account.orders.title"),
          text: this.$t("account.orders.content"),
        },
        {
          title: this.$t("account.unsubscribe.title"),
          text: this.$t("account.unsubscribe.content"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        account: {
          title: "My account",
          subtitle: "Manage all of your personal information",
          breadcrumb: "My account",
          account: {
            title: "My account",
            content: "",
          },
          personal: {
            title: "Personal data",
            content: "",
          },
          orders: {
            title: "Orders history",
            content: "",
          },
          password: {
            title: "Password",
            content: "",
          },
          newsletter: {
            title: "Newsletter subscription",
            content: "",
          },
          unsubscribe: {
            title: "Unsubscribe from Vooy Market",
            content: "",
          },
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
